import React, { useState } from 'react';
import { OptionItem } from '../types/types';

interface OptionListProps {
	options: Array<OptionItem>;
	onSelect: ( option: OptionItem ) => void;
	columns?: number;
}

const OptionList: React.FC<OptionListProps> = ( {
	options,
	onSelect,
	columns = 2,
} ) => {
	const [ selected, setSelected ] = useState<string | undefined>( undefined );

	const columnClass = columns === 3 ? 'col-md-4' : 'col-md-6';

	const selectOption = ( option: OptionItem ) => {
		const { path, id, url } = option;
		const value = url ? id : path;

		if ( value ) {
			setSelected( value );
			onSelect( option );
		}
	};

	return (
		<div className="c-guided-help__option-list">
			<div
				className="row"
				style={columns === 3 ? { minHeight: '11.5rem' } : undefined}
			>
				{options.map( ( option ) => {
					const { id, label, path, url, icon } = option;
					const labelClass = icon ? 'c-guided-help__option--icon' : '';

					return (
						<div key={id} className={columnClass}>
							<div className={`c-guided-help__option ${ labelClass }`}>
								<input
									className="sr-only"
									type="radio"
									name="nextPage"
									value={url ? id : path}
									id={id}
									checked={selected === ( url ? id : path )}
									onChange={() => selectOption( option )}
								/>
								<label htmlFor={id}>
									{!! icon && (
										<div className="c-guided-help__option-icon">
											<span className={icon}></span>
										</div>
									)}
									<div className="c-guided-help__option-text">{label}</div>
								</label>
							</div>
						</div>
					);
				} )}
			</div>
		</div>
	);
};

export default OptionList;
